import { defineLanguage } from "../registry";

export default defineLanguage({
  id: "ruby",
  filenames: ["Gemfile", "Rakefile", "Guardfile", "Vagrantfile", "config.ru"],
  runner: "ruby",
  config: {
    // As VS Code's Ruby support does: indent after def/class/do/if…, outdent at end/else/when….
    indentationRules: {
      increaseIndentPattern:
        /^\s*((begin|class|(private|protected)\s+def|def|else|elsif|ensure|for|if|module|rescue|unless|until|when|in|while|case)|([^#]*\sdo\b)|([^#]*=\s*(case|if|unless)))\b([^#{;]|("|'|\/).*\4)*(#.*)?$/,
      decreaseIndentPattern:
        /^\s*([}\]]([,)]?\s*(#|$)|\.[a-zA-Z_]\w*\b)|(end|rescue|ensure|else|elsif|when|in)\b)/,
    },
    onEnterRules: [
      {
        beforeText:
          /^\s*(def|class|module|if|unless|while|until|for|case|when|begin|rescue|ensure|else|elsif)\b.*$|\bdo(\s*\|[^|]*\|)?\s*$/,
        action: "indent",
      },
    ],
  },
});
